export default __webpack_public_path__ + "static/media/onboarding.9b8395b6.svg";